import React, { useState, useEffect } from "react";
import { useManualQuery } from "graphql-hooks";

import { CLIENT_EVENT_TYPE_LIST_QUERY } from "../../graphQL/event_type_qry";

export const GetTermEvents = () => {
  const [eventTypeData, setEventTypeData] = useState([]);

  const [getTenantEventTypeData] = useManualQuery(CLIENT_EVENT_TYPE_LIST_QUERY, {
    fetchPolicy: "network-only",
  });

  const clientId = localStorage.getItem("clientId");
  useEffect(() => {
    (() => getEventTypeList())();
  }, []);

  const getEventTypeList = async () => {
    // Get event type list
    const {
      loading: eventTypeDataLoading,
      error: eventTypeDataError,
      data: eventTypeData,
    } = await getTenantEventTypeData({
      variables: {
        clientId: parseInt(clientId),
      },
    });

    if (!eventTypeDataLoading && eventTypeData && eventTypeData.clientEventTypeList) {
      setEventTypeData(eventTypeData.clientEventTypeList);
    }
  };
  return eventTypeData;
};

export const PeriodComponents = {
  PERIOD: "Period",
};
